import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Avatar, Space} from 'antd';
import {StyledSubscriptionSnippet} from './StyledSubscriptionSnippet';
import {cardsHelpers, subscriptionsHelpers, textHelpers} from '../../../../utils/helpers';
import routes from '../../../../routes/routes.json';
import {WithLessCreditCardIcon} from '../../../../icons';


const SubscriptionSnippet = ({
  subscription,
  ...rest
}) => {

  const cardMaskedPan = subscription?.card_masked_pan;

  const name = subscriptionsHelpers.getSubscriptionName(subscription);

  const logo = subscription?.service?.logo || undefined;

  return (
    <StyledSubscriptionSnippet {...rest}>
      <Link to={`${routes.subscriptionsList}/${subscription.id}`}>
        <Space size='small' align='center'>
          <Avatar size={32} src={logo}>
            {textHelpers.getInitials(name)}
          </Avatar>
          <span>{name}</span>
        </Space>
      </Link>

      {cardMaskedPan && (
        <Link to={cardsHelpers.getCardDetailsUrl({ cardId: subscription?.card_id, ownerId: subscription?.card_owner?.id })}>
          <Space align='center'>
            {cardsHelpers.getLast4Digits(cardMaskedPan)}
            <WithLessCreditCardIcon />
          </Space>
        </Link>
      )}
    </StyledSubscriptionSnippet>
  );
}

SubscriptionSnippet.propTypes = {
  subscription: PropTypes.shape({
    card_id: PropTypes.string,
    card_owner: PropTypes.shape({
      id: PropTypes.string
    }),
    id: PropTypes.string,
    service: PropTypes.shape({
      logo: PropTypes.string
    }),
  })
}

export default SubscriptionSnippet;
